export default __webpack_public_path__ + "static/universlt-roman-e9672884bf3c84665a72d41961f111f0.woff2";